import { common } from '@mui/material/colors';
import BaseTextField from 'common/components/base-text-field';
// import { colors } from 'common/constants';
import React from 'react';
import { isMobile } from 'react-device-detect';
interface Props {
    name: string;
}
const QuestionTextbox: React.FC<Props> = ({ name }) => {
    return (
        <BaseTextField
            name={name}
            placeholder="Viết câu trả lời của bạn tại đây…"
            fullWidth
            multiline
            rows={isMobile ? 10 : 5}
            InputProps={{
                inputProps: {
                    maxLength: 255,
                },
            }}
            sx={{
                '& .MuiInputBase-root': {
                    backgroundColor: common.white,
                    borderRadius: '10px',
                },
            }}
        />
    );
};

export default QuestionTextbox;
